/* eslint-disable ember/classic-decorator-hooks, ember/no-computed-properties-in-native-classes */
import { inject as controller } from '@ember/controller';
import AssessmentController from '../assessments/assessment';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Options from '@linc-technologies/linced-common/enums/options';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';
import { isMobile } from '@linc-technologies/linced-common/utils/platform';

export default class _AssessmentController extends AssessmentController {
  @controller('people.person.page')
  pageController;

  // Services
  @service
  options;

  @service
  router;

  @tracked
  editingPost = false;

  @tracked
  postBeingEdited = null;

  @optionAlias(Options.REPORTING_SHOW_SUBJECTS_ON)
  showSubjectsOn;

  @tracked
  isMobile;

  @computed('model.page.{hasAssessments,assessments.length}', 'showSubjectsOn')
  get showSubjects() {
    if (
      this.model.page.get('hasAssessments') &&
      this.model.page.get('assessments.length') > 1
    ) {
      // Don't show subjects if there are multiple assessments on this Page.
      return false;
    }

    if (isEmpty(this.showSubjectsOn)) {
      // Show subjects by default if the option isn't set yet.
      return true;
    }

    return ['pages', 'both'].includes(this.showSubjectsOn);
  }

  init() {
    super.init(...arguments);
    this.isMobile = isMobile();
  }

  @action
  refresh() {
    this.refreshPage();
  }

  @action
  autoScroll(className) {
    let target = window.document.getElementsByClassName(className)[0];
    let container = window.document.querySelector('.main-content__container');
    if (!target || !container) {
      return;
    }
    let targetTop =
      target.getBoundingClientRect().top -
      container.getBoundingClientRect().top +
      container.scrollTop;
    container.scrollTo({
      top: targetTop - 50,
      behavior: 'smooth',
    });
  }

  @action
  newPost() {
    this.postBeingEdited = null;
    this.editingPost = true;
  }

  @action
  editPost(post) {
    this.editingPost = true;
    this.postBeingEdited = post;
  }

  @action
  closeEditPost() {
    this.editingPost = false;
    this.postBeingEdited = null;
    this.refreshPage();
  }

  // refreshPage reloads this route's model and the parent page's posts.
  refreshPage() {
    this.router.refresh('people.person.page.assessment');
    this.pageController.refresh();
  }
}
